export default function GameReconnectBanner({ recoveryStatus = "ready" }) {
  if (!recoveryStatus || recoveryStatus === "ready") return null;

  const contentByStatus = {
    reconnecting: {
      title: "Reconnecting…",
      message: "We are restoring your live game connection.",
    },
    recovered: {
      title: "Back in sync",
      message: "Your game state was recovered successfully.",
    },
    stale_session: {
      title: "Session expired",
      message: "Please rejoin the game lobby to continue.",
    },
    waiting_admin: {
      title: "Please wait",
      message: "Host is stabilizing the current game state.",
    },
  };

  const content =
    contentByStatus[recoveryStatus] || contentByStatus.reconnecting;

  return (
    <div
      style={{
        border: "1px solid rgba(255,255,255,0.25)",
        borderRadius: 12,
        padding: "10px 12px",
        marginBottom: 12,
        background: "rgba(8, 20, 44, 0.7)",
      }}
    >
      <strong>{content.title}</strong>
      <div style={{ fontSize: 13, opacity: 0.9 }}>{content.message}</div>
    </div>
  );
}
